import { SERVICE_NAME } from '@localstack/types';

import { PATH_PREFIX_RESOURCES } from './base';

const FIREHOSE_BASE_ROUTE = `${PATH_PREFIX_RESOURCES}/${SERVICE_NAME.FIREHOSE}`;

export const DEFAULT_FIREHOSE_ROUTES: Record<string, string> = {
  RESOURCES_FIREHOSE_STREAM: `${FIREHOSE_BASE_ROUTE}/delivery-streams/:deliveryStreamName`,
  RESOURCES_FIREHOSE_STREAMS: `${FIREHOSE_BASE_ROUTE}/delivery-streams`,
  RESOURCES_FIREHOSE_STREAM_CREATE: `${FIREHOSE_BASE_ROUTE}/delivery-streams/new`,
};
